module.exports = "/assets/c222f863ff7432192b1abf1ba6bbce16.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/IZ.png
// module id = 2617
// module chunks = 0